import React, { useEffect, useState } from 'react';

interface ConfettiPiece {
    id: number;
    x: number;
    y: number;
    rotation: number;
    color: string;
    size: number;
    velocityX: number;
    velocityY: number;
    rotationSpeed: number;
}

interface ConfettiProps {
    active: boolean;
    duration?: number;
    count?: number;
}

const COLORS = [
    '#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8',
    '#F7DC6F', '#BB8FCE', '#85C1E2', '#F8B739', '#52B788'
];

export const Confetti: React.FC<ConfettiProps> = ({ 
    active, 
    duration = 3000,
    count = 50 
}) => {
    const [pieces, setPieces] = useState<ConfettiPiece[]>([]);
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        if (active && !isActive) {
            setIsActive(true);
            
            // Generate confetti pieces
            const newPieces: ConfettiPiece[] = Array.from({ length: count }, (_, i) => ({
                id: i,
                x: Math.random() * 100,
                y: -10,
                rotation: Math.random() * 360,
                color: COLORS[Math.floor(Math.random() * COLORS.length)],
                size: Math.random() * 8 + 4,
                velocityX: (Math.random() - 0.5) * 2,
                velocityY: Math.random() * 2 + 1,
                rotationSpeed: (Math.random() - 0.5) * 10,
            }));

            setPieces(newPieces);

            // Clear after duration
            const timeout = setTimeout(() => {
                setPieces([]);
                setIsActive(false);
            }, duration);

            return () => clearTimeout(timeout);
        }
    }, [active, isActive, count, duration]);

    if (!isActive || pieces.length === 0) return null;

    return (
        <div className="fixed inset-0 pointer-events-none z-[150]">
            {pieces.map((piece) => (
                <div
                    key={piece.id}
                    className="absolute"
                    style={{
                        left: `${piece.x}%`,
                        top: `${piece.y}%`,
                        width: `${piece.size}px`,
                        height: `${piece.size}px`,
                        backgroundColor: piece.color,
                        transform: `rotate(${piece.rotation}deg)`,
                        animation: `confetti-fall ${duration}ms linear forwards`,
                        animationDelay: `${Math.random() * 200}ms`,
                        borderRadius: Math.random() > 0.5 ? '50%' : '2px',
                    }}
                />
            ))}
            <style>{`
                @keyframes confetti-fall {
                    0% {
                        transform: translateY(0) rotate(0deg);
                        opacity: 1;
                    }
                    100% {
                        transform: translateY(100vh) rotate(720deg);
                        opacity: 0;
                    }
                }
            `}</style>
        </div>
    );
};

export default Confetti;

